module.exports = __webpack_public_path__ + "2cf430a64ce52cbe76dd2aef2e0803ba.ttf";